<template>
  <Fragment v-if="translationsToEdit.length > 0">
    <label>{{ $ts('actions.translations') }}</label>
    <RsCollapse
      v-for="lang in translationsToEdit"
      :id="`collapse-language-${lang.languageCode}-${id}`"
      :key="lang.id"
      class="rs-collapse-translations"
      icon="language"
      accordion-card
      not-draggable
      :title="getLanguageName(lang)"
    >
      <template #content>
        <RsFormInput
          v-for="(trns, index) in lang.translations"
          :key="index"
          v-model="trns.value"
          :label="getFieldLabel(trns.key)"
          type="text"
          html-decode
          @input="$emit('input', translationsToEdit)"
        />
      </template>
    </RsCollapse>
  </Fragment>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ILanguages } from '@llws/lift-entity-interfaces';
import { cloneObject } from '@/shared';

export default defineComponent({
  name: 'RsCollapseTranslations',

  props: {
    id: {
      type: String,
      required: true,
    },

    value: {
      type: Array as PropType<ILanguages[]>,
      default: () => [],
    },
  },

  data() {
    return {
      translationsToEdit: [] as ILanguages[],
    };
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.translationsToEdit = cloneObject(this.value);
      },
    },
  },

  methods: {
    getLanguageName(lang: ILanguages): string {
      const code = lang.languageCode as string;
      const key = `languageNames.${code}`;
      const translated = this.$t(key) as string;
      // If i18n found a translation (key !== translation), use it; otherwise fall back to lang.name
      return translated !== key ? translated : (lang.name ?? code);
    },

    getFieldLabel(key: string): string {
      const i18nKey = `translationFieldKeys.${key}`;
      const translated = this.$t(i18nKey) as string;
      return translated !== i18nKey ? translated : this.$utils.capitalize(key.replace('_', ' '));
    },
  },
});
</script>

<style lang="scss">

</style>
